import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a18e0166&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a18e0166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18e0166",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a18e0166')) {
      api.createRecord('a18e0166', component.options)
    } else {
      api.reload('a18e0166', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a18e0166&scoped=true&", function () {
      api.rerender('a18e0166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userBlack/index.vue"
export default component.exports